(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["base.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div id=\"header\">\r\n    <div class=\"wrap\">\r\n        <a id=\"logo\" href=\"http://www.ksh.hu/?lang=";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "_lang"), env.opts.autoescape);
output += "\"><img src=\"https://www.ksh.hu/images/logos/";
if(runtime.contextOrFrameLookup(context, frame, "_lang") == "hu") {
output += "kshlogo_uj_60.png";
;
}
else {
output += "hcsologo_uj_60.png";
;
}
output += "\" alt=\"KSH logo\" height=\"60\"></a>\r\n        <p id=\"appname\">";
output += runtime.suppressValue(env.getFilter("trans").call(context, "app.name"), env.opts.autoescape);
output += "</p>\r\n        ";
var t_1;
t_1 = (runtime.contextOrFrameLookup(context, frame, "_lang") == "en"?"hu":"en");
frame.set("opposite_lang", t_1, true);
if(frame.topLevel) {
context.setVariable("opposite_lang", t_1);
}
if(frame.topLevel) {
context.addExport("opposite_lang", t_1);
}
output += "\r\n        <a id=\"lang\" class=\"lang_";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "opposite_lang"), env.opts.autoescape);
output += "\" href=\"";
output += runtime.suppressValue((lineno = 5, colno = 60, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["index",{"lang": runtime.contextOrFrameLookup(context, frame, "opposite_lang")}])), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(env.getFilter("trans").call(context, "head.lang_switch"), env.opts.autoescape);
output += "</a>\r\n        <div id=\"numbers\">&nbsp;</div>\r\n    </div>\r\n</div>\r\n\r\n<div id=\"header-menu\">\r\n    <div class=\"wrap\">\r\n        ";
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("main_menu.html", false, "base.html", false, function(t_3,t_2) {
if(t_3) { cb(t_3); return; }
callback(null,t_2);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
callback(null,t_4);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += "\r\n    </div>\r\n</div>\r\n\r\n<div id=\"main\">";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("main"))(env, context, frame, runtime, function(t_7,t_6) {
if(t_7) { cb(t_7); return; }
output += t_6;
output += "</div>\r\n\r\n<div id=\"footer\">\r\n    <div class=\"wrap\">\r\n        <div id=\"footer-menu\">\r\n            <a href=\"http://www.ksh.hu/?lang=";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "_lang"), env.opts.autoescape);
output += "\" target=\"_blank\">";
output += runtime.suppressValue(env.getFilter("trans").call(context, "footer.ksh_home"), env.opts.autoescape);
output += "</a>\r\n            | <a href=\"#/tartalom/";
if(runtime.contextOrFrameLookup(context, frame, "_lang") == "hu") {
output += "elerhetoseg";
;
}
else {
output += "contact/en";
;
}
output += "\">";
output += runtime.suppressValue(env.getFilter("trans").call(context, "footer.contacts"), env.opts.autoescape);
output += "</a>\r\n            | <a href=\"http://www.ksh.hu/copyright";
output += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "_lang") == "en"?"_eng":""), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(env.getFilter("trans").call(context, "footer.copyright"), env.opts.autoescape);
output += "</a>\r\n        </div>\r\n    </div>\r\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_main(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var frame = frame.push(true);
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_main: b_main,
root: root
};

})();
})();
